import * as React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {IHistory} from '../../interfaces';
import {UserModel} from '../../model/UserModel';
import {getAllUsers} from '../../services/userService';
import {Async} from '../reusableComponents/Async';
import {BasePage} from '../reusableComponents/BasePage';
import {Icon} from '../reusableComponents/Icon';
import {ListPage} from '../reusableComponents/ListPage';
import {Loader} from '../reusableComponents/Loader/Loader';
import {ListItem} from './ListItems';
import * as _ from 'lodash';
import './users.scss';
import {getCurrentUserUUID} from '../../utils/generalUtils';

export interface IUserListPageProps {
    instances: UserModel[];
    history: IHistory;
}

export class UserListPageImpl extends React.PureComponent<IUserListPageProps, {}> {
    constructor(props: IUserListPageProps) {
        super(props);
    }

    public promise = async () => {
        await getAllUsers();
    }

    public renderUserList = () => {
        return <ListPage
            instances={this.props.instances}
            listItemComponent={ListItem}
            searchBy={['Id', 'FirstName', 'AccessLevel', 'JobTitle', 'DateCreated', 'Active', 'Edit']}
            pageHeadings={['ID', 'Name', 'Level', 'Job Title', 'Created On', 'Status', 'Edit']}
            promise={this.promise}
            emptyListMessage="No Users Available"
            cols={[1, 3, 2, 2, 2, 1, 1]}
            chartTitle = "UserList"
        />;
    }

    public render() {
        const isAdmin = UserModel.isAdmin();
        return <BasePage title="User List" className="list-page-with-edit-delete" icon="users">
            <Async
                identifier="UserListPage"
                promise={this.promise}
                loader={<Loader type="async"/>}
                content={this.renderUserList()}
                error={<Loader type="async"/>}
            />
            <div className="options-container">
                {/* <div className="delete" >
                    <Icon icon="trash" />
                    &nbsp;
                    Delete
                </div> */}
                <div className="add-new" onClick={() => this.props.history.push('/users/create')}>
                    <Icon icon="plus"/>
                    &nbsp;
                    Add Single User
                </div>
                {isAdmin && <div className="add-new" onClick={() => this.props.history.push('/users/createMultiple')}>
                    <Icon icon="plus"/>
                    &nbsp;
                    Add Multiple User
                </div>}
            </div>
        </BasePage>;
    }
}

function mapStateToProps(state) {
    const currentUserId = getCurrentUserUUID();
    const usersList = UserModel.list();
    _.remove(usersList, (user) => {
        return user.props.id === currentUserId;
    });
    return {
        instances: usersList
    };
}

export const UserListPage = withRouter(connect<{}, {}, IUserListPageProps>(mapStateToProps)(UserListPageImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Users/UserListPage.tsx